import type { SVGProps } from 'react'
const WorkBasketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.27813 11.3679L9.1625 7.54326L8.16563 6.56173L5.26094 9.42173L3.81719 8.00019L2.8375 8.9648L5.27813 11.3679ZM1.875 14.0756C1.49688 14.0756 1.17318 13.943 0.903906 13.6779C0.634635 13.4128 0.5 13.094 0.5 12.7217V1.89096C0.5 1.51865 0.634635 1.19993 0.903906 0.934802C1.17318 0.669673 1.49688 0.537109 1.875 0.537109H7.375L11.5 4.59865V12.7217C11.5 13.094 11.3654 13.4128 11.0961 13.6779C10.8268 13.943 10.5031 14.0756 10.125 14.0756H1.875ZM6.6875 5.27557V1.89096H1.875V12.7217H10.125V5.27557H6.6875Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default WorkBasketIcon
